module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Footer/images/ribbon.0b53ecf8.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Footer/images/ribbon.png
// module id = 3455
// module chunks = 11